<template>
    <div class="main_container">
        <div id="background"
            :class="{ 'detail_background': selectedMessage !== null || showMessageForm || showMessageDetail }">
            <div v-if="selectedMessage === null && !showMessageForm && !showMessageDetail">
                <!-- 기존 메시지 리스트 -->
                <div class="category_container">
                    <div id="category_item" style="flex: 3;">활동명</div>
                    <div id="category_item" style="flex: 2;">변동액</div>
                    <div id="category_item" style="flex: 2;">잔액</div>
                    <div id="category_item" style="flex: 3;">변동시간</div>
                </div>
                <div v-for="list in displayedLists" :key="list.idx" class="message_item">
                    <div id="list_item" style="flex: 3;">
                        <label>{{ this.convertAction(list.action) }}</label>
                    </div>
                    <div id="list_item" style="flex: 2;">
                        <label v-html="checkActionMoney(list)"></label>
                    </div>
                    <div id="list_item" style="flex: 2;">
                        <label>{{ this.toNumberFormatOfKor(this.checkActionCurr(list)) }}</label>
                    </div>
                    <div id="list_item" style="flex: 3;">
                        <label>{{ formatDate(list.time) }} {{ ('&nbsp;') }} {{formatTime(list.time)}}</label>
                    </div>
                    <!-- <div class="list_remain" :style="{ color: message.time ? 'white' : 'transparent' }">{{
                        formatDate(message.send_time) || '' }}</div> -->
                </div>
                <!-- 페이지네이션 -->
                <div class="pagination" v-if="this.selectedMessage === null && !showMessageForm && !showMessageDetail">
                    <div class="page_btn_container" style="width: 92px;">
                        <button @click="prevPage" :disabled="currentPage === 1" class="button"
                            v-show="currentPage !== 1">이전</button>
                    </div>
                    <span class="page_number" style="width: 60px;">{{ currentPage }} / {{ totalPages }}</span>
                    <div class="page_btn_container" style="width: 92px;">
                        <button @click="nextPage" :disabled="currentPage === totalPages" class="button"
                            v-show="currentPage !== totalPages">다음</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from '../../js/store.js';
import API from '@/components/js/API';

export default {
    name: "message_board",
    components: {

    },
    data() {
        return {
            total: 0,
            lists: [],
            currentPage: 1,
            pageSize: 20,
            selectedMessage: null,
            replyMessage: null,
            showMessageForm: false, // 메시지 폼 표시 여부
            showMessageDetail: false, // 메시지 상세 보기 여부
            form: {}
        };
    },
    computed: {
        totalPages() {
            let total = Math.ceil(this.total / this.pageSize);
            return Math.max(total, 1); // 최소값을 1로 설정
        },
        displayedLists() {
            return this.lists.slice(0, 20);
        }
    },
    mounted() {
        // 페이지 로드 시 메시지 받아오기
        this.fetchList();
    },
    methods: {
        formatDate(dateString) {
            const date = new Date(dateString);
            const padZero = (number) => (number < 10 ? `0${number}` : number);
            if (date.toString() === 'Invalid Date') 
            {
                return '';
            }
            else
            {
                return `${date.getUTCFullYear()}-${padZero(date.getUTCMonth() + 1)}-${padZero(date.getUTCDate())}`;
            }
        },
        formatTime(dateString) {
            const date = new Date(dateString);
            const padZero = (number) => (number < 10 ? `0${number}` : number);
            if (date.toString() === 'Invalid Date') 
            {
                return '';
            }
            else
            {
                return `${padZero(date.getUTCHours())}:${padZero(date.getUTCMinutes())}`;
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.fetchList();
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
                this.fetchList();
            }
        },
        fetchList() {
            this.form = {
                user_id: store.state.user.id,
                page: this.currentPage-1,
                page_num: this.pageSize
            };
            API.AxiosPost('users/getMoneyHistory', this.form, true,
                response => {
                    console.log(response);
                    if (response.data.code == '200') {
                        console.log(response.data);
                        this.lists = Array.isArray(response.data.data.data) ? response.data.data.data : []; // 배열로 변환하여 할당
                        console.log('page : ' + this.currentPage + ' / count : ' + this.lists.length);
                        this.total = response.data.data.total;

                        const money_data = {
                            cash: response.data.data.user.cash,
                            credit: response.data.data.user.credit,
                            point: response.data.data.user.point,
                        }
                        store.commit('updateMoney', money_data)
                    }
                }
            )
        },
        convertAction(actionNum) {
            const actions = {
                1: '베팅',
                2: '베팅 취소',
                3: '베팅 당첨금',
                5: '입금',
                6: '입금 취소',
                9: '환전',
                10: '포인트 전환',
                11: '빙고 보너스 지급',
                12: '빙고 무당첨 환불',
                99: '이벤트금 지급',
            };
            return actions[actionNum] || '';
        },
        checkActionCurr(list) {
            switch(list.action)
            {
                case 1:
                    return list.curr1;
                default:
                    return list.curr2;
            }
        },
        checkActionMoney(list) {
            const isNegative = [1, 6, 9].includes(list.action);
            const symbol = isNegative ? '▼' : '▲';
            const colorClass = isNegative ? 'negative' : 'positive';
            return `<span class="${colorClass}">${symbol}</span>${this.toNumberFormatOfKor(list.money)}`;
        },
        toNumberFormatOfKor(num) {
            return `${num.toLocaleString('ko-KR')}`;
        }
    }
};
</script>


<style>
.list_name {
    float: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: center;
    padding-left: 10px;
    color: white;
}
.list_used {
    float: left;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: white;
}
.list_remain {

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: white;
}
.list_time {

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: white;
}
.message_info h3 {
    font-size: 18px; /* 원하는 폰트 크기로 조정하세요 */
}

.message_date {
    font-size: 16px; /* 원하는 폰트 크기로 조정하세요 */
}
.category_container{
    display: flex;
    margin-left: 10px;
    margin-right: 10px;
}
.message_item {
    display: flex;
    height: 25px;
    margin-left: 10px;
    margin-right: 10px;
    border-bottom: 1px solid #adadadc4;
    /* 구분선 스타일링 */
}
.msg_btn{
    height: 40px;
    width: 250px;
    border: 1px;
    border-radius: 20px 20px 20px 20px / 20px 20px 20px 20px;
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #2d88ff;
    color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
.detail_title h3 {
    font-size: 18px;
    margin-bottom: 5px;
    color: white; /* 제목 폰트 색상 추가 */
}

.detail_date {
    font-size: 16px;
}

.detail_content p {
    font-size: 18px;
    line-height: 3;
    color: white;
}

.button_space {
    margin-right: 10px; /* 버튼 사이의 간격 조정 */
}
.send_button,
.close_button {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.send_button {
    background-color: #4CAF50;
    color: white;
}

.close_button {
    background-color: #f44336;
    color: white;
}
#category_item {
    font-size: 16px;
    font-weight: bold;
    color: white;
    text-align: center;
    margin-top: 2px;
    margin-bottom: 2px;
}
#list_item {
    font-size: 16px;
    color: white;
    text-align: center;
    margin-top: 2px;
    margin-bottom: 2px;
}
.positive {
    color: green;
}

.negative {
    color: red;
}
</style>